import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Chart as ChartJS } from "chart.js/auto";
// import { Line } from "react-chartjs-2";
import axios from "axios";
import { Image, Spin } from "antd";
import { Tabs } from "antd";
import { millify } from "millify";
import getSymbolFromCurrency from "currency-symbol-map";

import { CurrencyContext } from "../services/currencyContext";

import {
  Col,
  Row,
  Typography,
  Card,
  Avatar,
  Statistic,
  Space,
  Divider,
  Button,
} from "antd";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
} from "recharts";

import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import { duration } from "moment";

const { TabPane } = Tabs;

const { Meta } = Card;

const { Title } = Typography;

const LineChart1 = () => {
  const { id } = useParams();

  const [priceHistory, setpriceHistory] = useState([]);
  const [singleCoinData, setsinglecoinData] = useState([]);
  const [days, setDays] = useState(365);
  const [fontColor, setfontColor] = useState("");

  const { currencyState } = useContext(CurrencyContext);

  const [currency] = currencyState;

  const currencySymbol = getSymbolFromCurrency(currency.toUpperCase());

  const HistoricalChart = (id, days = 365, currency) =>
    `https://api.coingecko.com/api/v3/coins/${id}/market_chart?vs_currency=${currency}&days=${days}`;

  const SingleCoin = (id) => `https://api.coingecko.com/api/v3/coins/${id}`;

  useEffect(() => {
    getHistoricData();
    getSingleCoinData(id);
    console.log("rendering.............");
    console.log(singleCoinData, "44444");
    if (
      singleCoinData?.market_data
        ?.market_cap_change_percentage_24h_in_currency?.[currency] > 0
    ) {
      setfontColor("green");
      console.log("green");
    } else {
      setfontColor("red");
      console.log("red");
    }
  }, [days, currency]);

  async function getHistoricData() {
    try {
      const response = await axios.get(HistoricalChart(id, days, currency));
      // setCryptoList(response.data);
      setpriceHistory(response.data.prices);
    } catch (error) {
      console.error(error);
    }
  }

  async function getSingleCoinData(id) {
    try {
      const response = await axios.get(SingleCoin(id));
      // setCryptoList(response.data);
      setsinglecoinData(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  const coinPrice = [];
  const coinTimestamp = [];
  const priceArray = [];

  priceHistory.map((item) => {
    const date = new Date(item[0]);
    let time =
      date.getHours() > 12
        ? `${date.getHours() - 12}:${date.getMinutes()} PM`
        : `${date.getHours()}:${date.getMinutes()} AM`;

    const obj = {
      time: days === 1 ? time : date.toLocaleDateString(),
      price: item[1],
    };

    priceArray.push(obj);

    coinPrice.push(item[1]);

    if (days === 1) {
      coinTimestamp.push(time);
    } else {
      coinTimestamp.push(date.toLocaleDateString());
    }
  });

  console.log(priceArray, "lineChart");

  const chartDays = [
    { label: "24 Hours", value: "1" },
    { label: "30 days", value: "30" },
    { label: "3 months", value: "90" },
    { label: "1 year", value: "365" },
  ];

  const data = {
    labels: coinTimestamp,
    datasets: [
      {
        label: `Price   `,
        data: coinPrice,
        fill: false,
        backgroundColor: ["#f38b4a", "#56d798", "#ff8397", "#6970d5"],
        borderColor: "#8D8DAA",
      },
    ],
  };

  const options = {
    scales: {
      type: "category",
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    elements: {
      point: {
        radius: 1,
      },
    },
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <Card
          style={{ padding: "5px", margin: "20px" }}

          /* actions={[
      <SettingOutlined key="setting" />,
      <EditOutlined key="edit" />,
      <EllipsisOutlined key="ellipsis" />,
    ]} */
        >
          {" "}
          <div style={{ display: "flex" }}>
            <Avatar
              src={singleCoinData?.image?.large}
              size={64}
              style={{ padding: "5px" }}
            />
            <Title level={2} style={{ marginTop: "12px", marginLeft: "10px" }}>
              {" "}
              {singleCoinData?.name}{" "}
            </Title>

            {/*    <Meta
              avatar={}
              title={singleCoinData?.name}px
            /> */}
            <h1 style={{ marginTop: "17px", marginLeft: "50px" }}>
              {" "}
              Rank .{singleCoinData?.market_cap_rank}{" "}
            </h1>
          </div>
        </Card>

        <div style={{ margin: "10px", padding: "10px" }}>
          <Card>
            <div
              className="statistics"
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              {/*     <Statistic
              title="Market Cap"
              value={singleCoinData?.market_data?.market_cap?.inr}
            /> */}
              <Space size="middle">
                <Statistic
                  title="Current Price"
                  value={priceArray[priceArray.length - 1]?.price.toFixed(3)}
                  valueStyle={{ color: "gray", fontSize: "28px" }}
                  prefix={currencySymbol}
                />
                {/*     <Statistic
              title="TotalSupply"
              value={singleCoinData?.market_data?.total_supply}
            /> */}
              </Space>
            </div>

            <Card>
              {singleCoinData ? (
                <ResponsiveContainer width="100%" aspect={3}>
                  <AreaChart
                    width={730}
                    data={priceArray}
                    // aspect={1}
                    margin={{ top: 10, bottom: 0 }}
                  >
                    <defs>
                      <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                        <stop
                          offset="5%"
                          stopColor="#8D8DAA"
                          stopOpacity={0.8}
                        />
                        <stop
                          offset="95%"
                          stopColor="#8D8DAA"
                          stopOpacity={0}
                        />
                      </linearGradient>
                      <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                        <stop
                          offset="5%"
                          stopColor="#9A86A4"
                          stopOpacity={0.8}
                        />
                        <stop
                          offset="95%"
                          stopColor="#82ca9d"
                          stopOpacity={0}
                        />
                      </linearGradient>
                    </defs>
                    <XAxis
                      dataKey="time"
                      style={{
                        fontFamily: "monospace",
                        fontSize: "10px",
                        fontWeight: "bold",
                        textColor: "#4B5D67",
                      }}
                      angle={-40}
                      textAnchor="middle"
                      sclaeToFit="true"
                      axisLine={false}
                      tick={{ fill: "#4B5D67" }}
                    />

                    <Tooltip />
                    <Area
                      // type="monotone"
                      dataKey="price"
                      stroke="#2F8F9D"
                      fillOpacity={0.8}
                      fill="url(#colorUv)"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              ) : (
                <Spin />
              )}
            </Card>
          </Card>
        </div>
        <div
          style={{
            width: "50%",
            margin: "20px auto",
            padding: "25px",
            display: "flex",
            alignItems: "centre",
            justifyContent: "space-between",
          }}
        >
          {chartDays.map((item) => {
            return (
              <Button
                style={{ borderRadius: "5px" }}
                color="primary"
                //onClick={setDays(item.value)}
                onClick={() => setDays(item.value)}
              >
                {item.label}{" "}
              </Button>
            );
          })}
        </div>
      </div>

      <div></div>
    </>
  );
};

export default LineChart1;
